import React, { useRef, useState} from "react";
import Switch from "react-bootstrap-switch";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import { ErrorMessage, useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";



// components
import { CustomMiniButtonX,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM, MAX_NAME, REQUIRED
} from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";

// components
import SelectGeneric from "../../../components/select/selectGeneric";

// services & providers
import {currencyProvider} from "../../../providers/currencyProvider";
import {langService} from "../../../jwt/_services";
import {translateStatusProvider} from "../../../providers/configuration/translateStatusProvider";
import {confirmAlert} from "react-confirm-alert";
import FirebaseTarget from "../../../components/firebaseTarget/firebaseTarget";

const LangForm = props => {
    const { editMode, domainObject } = props.formProps;
    const { app } = props.mainProps;

    // Banderas
    const [status, setStatus] = useState( domainObject?.status ? domainObject?.status : false);
    const [translateBase, setTranslateBase] = useState(domainObject?.translateBase !== undefined ? domainObject?.translateBase : null);
    const [enabledToEdit, setEnabledToEdit] = useState(domainObject?.enabledToEdit !== undefined ? domainObject?.enabledToEdit : null);
    const [toPreload, setToPreload] = useState(domainObject?.toPreload !== undefined ? domainObject?.toPreload : null);
    const [saveHisTranslation, setSaveHisTranslation] = useState(domainObject?.saveHisTranslation !== undefined ? domainObject?.saveHisTranslation : null);
    const [isDefault, setIsDefault] = useState(domainObject?.isDefault !== undefined ? domainObject?.isDefault : null);

    const [currencyId, setCurrencyId] = useState(domainObject?.currency?.id || null);

    const [showHistoryModal, setShowHistoryModal] = useState(true);

    const modalHistoryRef = useRef(null);

    const [translateStatus, setTranslateStatus] = useState(domainObject?.translateStatus?.id)

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        nativeName: Yup.string().required(REQUIRED),
        twoLetterCode: Yup.string().required(REQUIRED),

    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            name: domainObject?.name,
            nativeName: domainObject?.nativeName,
            twoLetterCode: domainObject?.twoLetterCode,
            threeLetterCode: domainObject?.threeLetterCode,
            icon: domainObject?.icon
        }
    });

    const submitSwitch = (data) => {
        if (app?.fbDataBase !== undefined) {
            onSubmit(data);
        } else {
            confirmSubmit(data);
        }
    }

    const confirmSubmit = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => {
            return <FirebaseTarget
                className={"langLabel"}
                data={data}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        }
    });

    const onSubmit = (data, fbData, _) => {

        let dataRequest = {
            item : {
                ...data,

                // Booleans
                status : status,
                toPreload : toPreload,
                isDefault : isDefault,
                translateBase : translateBase,
                enabledToEdit : enabledToEdit,
                saveHisTranslation : saveHisTranslation,
            }
        };

        if (currencyId)
            dataRequest.item.currency = { id: currencyId };

        if(translateStatus)
            dataRequest.item.translateStatus = translateStatus;

        if (app?.fbDataBase !== undefined) {
            dataRequest.fbDataBase = { id : app?.fbDataBase?.id }
        } else {
            dataRequest.noDb = fbData.noDb;
            dataRequest.allDb = fbData.allDb;
            dataRequest.existingDb = fbData.existingDb;

            fbData?.fbDataBase && fbData?.fbDataBase?.id && (dataRequest.fbDataBase = { id : fbData.fbDataBase.id });
        }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(langService, id, dataRequest)
        } else {
            genericActions.save(langService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }

    return (<>
    <Form onSubmit={handleSubmit(submitSwitch)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>
                    {FORM}
                    <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_SAVE}
                            icon={'fa-save'}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        }
                        <CustomMiniButtonX
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>

                <CardBody className={'card-body-modal'}>

                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input type="text" name="name"
                                       placeholder="Nombre"
                                       innerRef={register}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Nombre nativo</Label>
                                <Input type="text" name="nativeName"
                                               placeholder="Nombre nativo"
                                               innerRef={register}
                                               className={(errors.nativeName ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="nativeName" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>Código 2 dígitos</Label>
                                        <Input type="text" name="twoLetterCode"
                                               placeholder="Código (2 dígitos)"
                                               innerRef={register}
                                               className={(errors.twoLetterCode ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="twoLetterCode" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>Código 3 dígitos</Label>
                                        <Input type="text" name="threeLetterCode"
                                               placeholder="Código (3 dígitos)"
                                               innerRef={register}
                                               className={(errors.threeLetterCode ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="threeLetterCode" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>Icono</Label>
                                        <Input type="text" name="icon"
                                               placeholder="Icono"
                                               innerRef={register}
                                               className={(errors.icon ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="icon" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="2">
                                    <FormGroup>
                                        <Label >Activo</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={status}
                                                innerRef={register}
                                                onChange={_ => setStatus( !status )}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>Lenguaje por defecto</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={isDefault}
                                                innerRef={register}
                                                onChange={_ => setIsDefault(!isDefault)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>Base de traducción</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={translateBase}
                                                innerRef={register}
                                                onChange={_ => setTranslateBase(!translateBase)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>De precarga</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={toPreload}
                                                innerRef={register}
                                                onChange={_ => setToPreload(!toPreload)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>Se puede editar</Label>
                                        <br />
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={enabledToEdit}
                                                innerRef={register}
                                                onChange={_ => setEnabledToEdit(!enabledToEdit)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>¿Guardar su traducción?</Label>
                                        <br />
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={saveHisTranslation}
                                                innerRef={register}
                                                onChange={_ => setSaveHisTranslation(!saveHisTranslation)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <FormGroup>
                                            <Label>Moneda por defecto</Label>
                                            <SelectGeneric
                                                initialValue={ currencyId }
                                                setExternalValue={ setCurrencyId }
                                                provider = { currencyProvider }
                                            />
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <FormGroup>
                                            <Label>Translate status</Label>
                                            <SelectGeneric
                                                initialValue={ translateStatus}
                                                setExternalValue={ setTranslateStatus }
                                                provider = { translateStatusProvider }
                                            />
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                </CardBody>
            </Card>
        </Form>
            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(LangForm)